// extracted by mini-css-extract-plugin
export var answer = "BaseFaq-module--answer--e93b3";
export var content = "BaseFaq-module--content--24e53";
export var contentWrapper = "BaseFaq-module--contentWrapper--18481";
export var faqItem = "BaseFaq-module--faqItem--e6b59";
export var list = "BaseFaq-module--list--188ed";
export var open = "BaseFaq-module--open--cf60d";
export var paragraph = "BaseFaq-module--paragraph--7ec07";
export var question = "BaseFaq-module--question--649f3";